<template>
  <div>
    <v-card>
      <v-toolbar card color="white">
        <v-text-field
          flat
          solo
          hide-details
          prepend-icon="search"
          placeholder="Tìm trên danh sách sim"
          v-model="table.searchText"
          v-on:keyup.enter="search()"
        ></v-text-field>
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="exportToExcel()">
            <v-icon>save_alt</v-icon>
          </v-btn>
          <span>Tải về danh sách sim</span>
        </v-tooltip>
        <v-menu offset-y origin="center center" :nudge-bottom="10">
          <v-btn icon slot="activator">
            <v-icon>filter_list</v-icon>
          </v-btn>
          <v-card>
            <v-card-title>Bộ lọc</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-radio-group v-model="filter" column>
                <v-radio label="Tất cả" value="all"></v-radio>
                <v-radio label="Sim đã kích hoạt" value="activated"></v-radio>
                <v-radio label="Sim chưa kích hoạt" value="unActivated"></v-radio>
                <v-radio label="Sim chưa kích hoạt quá 3 tháng" value="expired"></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-menu>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <v-data-table
          item-key="id"
          :headers="table.headers"
          :items="datasourceFiltered"
          :rows-per-page-items="[10,20,50,100]"
          :loading="isLoading"
          @update:pagination="changePage"
          :total-items="totalItems"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.ownerAccountName }}</td>
            <v-btn
              flat
              round
              small
              color="primary"
              :to="getAccountDetailLink(props.item.accountId)"
              class="link-button account-name"
            >{{ props.item.accountName }}</v-btn>
            <td>{{ props.item.iccId }}</td>
            <td>{{ props.item.phone }}</td>
            <td>{{ props.item.telco }}</td>
            <td>{{ props.item.data }}</td>
            <td>
              <b
                class="red--text"
                v-if="isSimExpired(props.item)"
              >{{ getDateFormatted(props.item.telcoActivationDate) }}</b>
              <span v-else>{{ getDateFormatted(props.item.telcoActivationDate) }}</span>
            </td>
            <td>{{ getDateFormatted(props.item.initExpiryDate) }}</td>
            <td>{{ props.item.initPrepaidAmount }}</td>
            <td>{{ getDateFormatted(props.item.firstUsedUtcTicks) }}</td>
            <td class="no-wrap">{{ getDateFormatted(props.item.createdDate) }}</td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import moment, { months } from 'moment';

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    datasource: {
      type: Array,
      default: []
    },
    totalItems: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      table: {
        searchText: '',
        headers: [
          {
            text: 'Nhà cung cấp',
            value: 'ownerAccountName'
          },
          {
            text: 'Khách hàng',
            value: 'accountName'
          },
          {
            text: 'ICCID',
            value: 'iccId'
          },
          {
            text: 'Số điện thoại',
            value: 'phone'
          },
          {
            text: 'Nhà mạng',
            value: 'telco'
          },
          {
            text: 'Dung lượng (KB)',
            value: 'data'
          },
          {
            text: 'Ngày kích hoạt (Khởi tạo)',
            value: 'telcoActivationDate'
          },
          {
            text: 'Ngày hết hạn (Khởi tạo)',
            value: 'initExpiryDate'
          },
          {
            text: 'Số dư (Khởi tạo)',
            value: 'initPrepaidAmount'
          },
          {
            text: 'Lần sử dụng đầu tiên',
            value: 'firstUsedUtcTicks'
          },
          {
            text: 'Ngày tạo',
            value: 'createdDate'
          }
        ]
      },
      filter: 'all',
      datasourceFiltered: this.datasource,
      moment: moment,
      pagination: {
        keySearch: '',
        pageIndex: 1,
        pageSize: 10
      }
    };
  },
  watch: {
    filter () {
      let filtered = [];
      switch (this.filter) {
        case 'activated': {
          filtered = this.datasource.filter(a => a.firstUsedUtcTicks);
          break;
        }
        case 'unActivated': {
          filtered = this.datasource.filter(
            a => !a.firstUsedUtcTicks && !a.lastDeviceId
          );
          break;
        }
        case 'expired': {
          filtered = this.datasource.filter(a => this.isSimExpired(a));
          break;
        }
        default:
          filtered = this.datasource;
          break;
      }

      this.datasourceFiltered = filtered;
    },
    datasource () {
      this.datasourceFiltered = this.datasource;
    }
  },
  methods: {
    getAccountDetailLink: accountId => `/account/detail?accountId=${accountId}`,
    getDateFormatted: value => (value ? new Date(value).toISOString().slice(0, 10) : ''),
    exportToExcel () {
      if (this.datasourceFiltered.length === 0) {
        window.getApp.showMessage('Không có dữ liệu', 'error');
        return;
      }

      let dataToExport = [];
      this.datasourceFiltered.map(item => {
        let data = {
          'Nhà cung cấp': item.ownerAccountName,
          'Khách hàng': item.accountName,
          ICCID: item.iccId,
          'Số điện thoại': item.phone,
          'Ngày kích hoạt (Khởi tạo)': item.telcoActivationDate
            ? new Date(item.telcoActivationDate).toISOString().slice(0, 10)
            : '',
          'Ngày hết hạn (Khởi tạo)': item.initExpiryDate
            ? new Date(item.initExpiryDate).toISOString().slice(0, 10)
            : '',
          'Số dư (Khởi tạo)': item.initPrepaidAmount,
          'Dung lượng (KB)': item.data,
          'Lần sử dụng đầu tiên': item.firstUsedUtcTicks
            ? new Date(item.firstUsedUtcTicks).toISOString().slice(0, 10)
            : '',
          'Ngày tạo': new Date(item.createdDate).toISOString().slice(0, 10)
        };
        dataToExport.push(data);
        return 0;
      });

      let sheet = XLSX.utils.json_to_sheet(dataToExport);
      let wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, sheet, 'Sims');
      XLSX.writeFile(wb, `Sims-${this.filter}.xlsx`);
    },
    isSimExpired (item) {
      return (!item.firstUsedUtcTicks && !item.lastDeviceId && item.telcoActivationDate && moment(item.telcoActivationDate).add(3, 'months') < moment());
    },

    search () {
      this.pagination.keySearch = this.table.searchText.trim();
      this.$emit('changePage', this.pagination);
    },

    changePage (pagination) {
      if (this.pagination.pageIndex !== pagination.page || this.pagination.pageSize !== pagination.rowsPerPage) {
        this.pagination.pageIndex = pagination.page;
        this.pagination.pageSize = pagination.rowsPerPage;
        this.$emit('changePage', this.pagination);
      }
    }
  }
};
</script>
<style scoped>
.v-card__text {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.link-button {
  min-width: 0px !important;
  margin-left: 15px !important;
}
.dealer-name {
  min-width: 0px !important;
  margin-left: -8px !important;
}
.account-name {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/sim/components/list.vue